import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersDetailFormsEditView } from './edit/edit';
import { OrderDetailsFormsDetailView } from './detail/detail';
import { OrdersDetailFormsModule } from './controllers/OrdersDetailFormsController'
import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';

export const OrderDetailsFormsView = angular
  .module('acme.view.application.orders.detail.forms', [
    uiRouter,
    'ui.bootstrap',
    OrdersDetailFormsModule,
    OrderDetailsFormsDetailView,
    'acme.view.application.orders.detail.forms.print',
    OrdersDetailFormsEditView,
  ])

  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.orders.detail.forms',
      url: '/forms',
      views: {
        'subviews-main': {
          controller: 'OrdersDetailFormsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/detail/forms/forms.tpl.html',
        },
      },
      data: {
        pageTitle: ' Forms Summary  ',
        /** Secure With Permissions **/
        permissions: ['ORDER_VIEW'],
        enablePreferences: true,
      },
      resolve: {
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    });
  }).name;
